import { ReactNode } from "react";

import { cn } from "./cn";

// 화면 안 주의 띠. 톤은 지금 warning 하나 — 하드코딩 amber 를 대신한다.
const TONE_CLASS = {
  warning: "border-warning/30 bg-warning-bg text-warning",
} as const;

interface Props {
  tone: keyof typeof TONE_CLASS;
  children: ReactNode;
  className?: string;
  // false 면 role=status 를 빼 보이고 읽히는 정적 글로 — 알림 읽기를 화면의 live 영역 하나에 맡길 때.
  live?: boolean;
  testId?: string;
}

const Banner = ({ tone, children, className, live = true, testId }: Props) => (
  <p className={cn("rounded-md border px-3 py-2 text-sm", TONE_CLASS[tone], className)} data-testid={testId} role={live ? "status" : undefined}>
    {children}
  </p>
);

export default Banner;
